// Generated by GitHub Copilot
import { Api } from '#core/api/Api.ts'
import type { SsoProvider } from '#core/auth/authentication-provider.ts'
import { setServiceWorkerToken } from '#core/auth/serviceWorkerToken.ts'
import Token from '#core/entities/auth/accounts/Token.ts'

/** SSO sign-in: the round trip through a provider's authorize page and back to the app's `/sso/{provider}/callback`. */
export default class SsoApi extends Api<SsoApi> {
  private static basePath(provider: SsoProvider): string {
    return `auth/sso/${provider}`
  }

  /** The provider URL to send the browser to for a fresh sign-in; 503 `not_configured` when the provider is not set up. */
  public async start(provider: SsoProvider): Promise<string> {
    const result = await this.get<{ authorize_url: string }>(`${SsoApi.basePath(provider)}/start`)
    return result!.authorize_url
  }

  /** Like {@link start}, but the round trip connects the provider's account to the signed-in user. */
  public async linkStart(provider: SsoProvider): Promise<string> {
    const result = await this.get<{ authorize_url: string }>(`${SsoApi.basePath(provider)}/link/start`)
    return result!.authorize_url
  }

  /**
   * Redeems the `code` and `state` the provider returned and stores the session, for a sign-in and a link
   * alike. Throws 400 (unknown/expired state, refused code), 403 `sso_required` (disabled connection), 403
   * (no access), 409 `email_in_use`, 409 (account linked to another user), 502, 503 `not_configured`.
   */
  public async callback(provider: SsoProvider, code: string, state: string): Promise<Token> {
    const token = await this.post<Token>(`${SsoApi.basePath(provider)}/callback`, { code, state }, Token)
    await setServiceWorkerToken({ ...token! })
    return token!
  }
}
